import { render, staticRenderFns } from "./HeaderDashboard.vue?vue&type=template&id=5f58d671"
import script from "./HeaderDashboard.vue?vue&type=script&lang=js"
export * from "./HeaderDashboard.vue?vue&type=script&lang=js"
import style0 from "./HeaderDashboard.vue?vue&type=style&index=0&id=5f58d671&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports